<script lang="ts">
    import { onMount } from 'svelte';
    import { theme } from '../../../services/stores/theme-store.js';

    export let customerCode: string;
    export let customerName: string;
    export let customerId: string;

    // Derive a sanitized slug from customerName: lowercase, letters and numbers only
    $: customerSlug = customerName.toLowerCase().replace(/[^a-z0-9]/g, '');

    onMount(async () => {
        // Load customer-specific data here
    });
</script>

<div class="customer-user home">
    <div class="flex flex-col items-left">
        <div class="self-center text-center flex flex-col items-center">
            <img src="/assets/images/customer/{customerSlug}/islr_program_{$theme}.png" alt="iSLR Logo" class="w-40">
            <h1>Welcome to the iSLR platform</h1>
        </div>
        <p class="welcome-text">Developed by OPEN Health in support of iSLR programs, this platform provides streamlined, AI-powered access to insights from literature reviews. It enables you to efficiently explore evidence across projects and surface relevant insights to support informed decision-making.</p>
        <p class="welcome-text">You can browse projects and associated material to identify information relevant to your therapeutic area, indication, or research focus.</p>
        <h2 class="self-center">Getting started</h2>
        <p class="welcome-text">Navigate to the Browse & Search page to begin. Use the browse panel to explore projects and files, or use search to review available evidence and locate specific insights.</p>
    </div>
    <div class="flex flex-row align-left">
        <p class="team mt-4">- The OPEN Health Team</p>
    </div>
</div>